import { GET_PASS_BY_COLORS, GET_TICKET_BY_SHAPE } from './../../../../api/apiRoutes';
import { Assort } from "./../../../../models/Assort";
import { useState } from "react";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../utils/hooks/useFacility";
import { GET_TICKET_BY_ASSORTGROUP, GET_TICKET_BY_COLORS } from "../../../../api/apiRoutes";

export default function useTicketsByAssortGroup() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [assorts, setAssortByAssortGroup] = useState<Assort[]>([]);

  const requestGetTicketsByAssortGroup = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_ASSORTGROUP(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
    }
  };

  const requestGetTicketsByColor = async (objectDB: number, objectId: number) => {
    const ids = `${objectDB} , ${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_COLORS(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
    }
  };

  const requestGetTicketsByShape = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_TICKET_BY_SHAPE(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
    }
  };

  const requestGetPassesByColor = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_PASS_BY_COLORS(facilityIds, ids));
    if (!isError) {
      setAssortByAssortGroup(result);
    }
  };


  
  return {
    requestGetPassesByColor,
    requestGetTicketsByColor,
    requestGetTicketsByAssortGroup,
    requestGetTicketsByShape,
    assorts,
  };
}
